import { useState } from "react";
import { Label, TextStyle, TextField } from "@lannister/duplo";

import { ReactComponent as EmptyWallet } from "../../assets/icons/empty-wallet.svg";
import { ValidateNumeric } from "./utils";

const Wallet = ({ handleChange}) => {
  const [paymentNumber, setPaymentNumber] = useState("");

  const onPaymentNumberChange = (value) => {
    console.log("payment_number", value);
    setPaymentNumber(value);
    handleChange("payment_number", value);
  }

  return (
        <div style={styles.field}>
            <TextField
                label="Mobile Number"
                value={paymentNumber} 
                onChange={e => onPaymentNumberChange(e.target.value)}
                rightIcon={<EmptyWallet />}
                maxLength={19}
                onInput={
                (event) => {
                    ValidateNumeric(event);
                }}
            />
            <Label
                labelText="Enter the phone number associated to your wallet"
                textStyle={TextStyle.BaseMedium}
            />
        </div>
  );
};

const styles = {
  field: {
    flex: 1,
    minWidth: 0,
  },
};

export default Wallet;
